import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext.js";
import { useNavigate } from "react-router-dom";

import "../styles/AccountPage.css";

const AccountPage = () => {
    const { currentUser, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    if (!currentUser) {
        return <p>Chargement du compte...</p>;
    }

    return (
        <div className="profile-container">
            <h1>Compte</h1>
            <div className="profile-details">
                <p><strong>Prénom :</strong> {currentUser.first_name}</p>
                <p><strong>Nom :</strong> {currentUser.last_name}</p>
                <p><strong>Email :</strong> {currentUser.mail}</p>
                <p><strong>Gestion : </strong> <a target="_blank" href="https://billing.stripe.com/p/login/5kA2aC7yh6qA2mQfYY" rel="noreferrer">Factures / Abonnement</a></p>
            </div>
            <button className="logout-button" onClick={() => {
                logout();
                navigate("/login");
            }}>Se déconnecter</button>
        </div>
    );
};

export default AccountPage;